// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-info-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.video-info-top .published-at {
  font-size: 14px;
  color: var(--color_neutral_800);
}
.video-info-top .video-published-at {
  display: flex;
  align-items: center;
  gap: 8px;
}
.video-info-top .video-published-at .error-message {
  color: var(--color_neutral_500);
  font-size: 14px;
}
.video-info-top .update-post-button {
  gap: 8px;
}
.video-info-top .update-post-button__icon--spinning {
  animation: update-post-button-spin 1s linear infinite;
}

.video-info .video-creator {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.video-info .video-creator .video-creator-label {
  margin: 0 4px;
  color: var(--gray_dark1);
}
.video-info .video-creator .video-creator-link .CreatorCardOnHover > h6 {
  position: relative;
  top: 4px;
}
.video-info .video-creator .video-creator-link .CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee {
  width: 265px;
}

@keyframes update-post-button-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/posts/video-info/video-info.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,+BAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAJ;AAEI;EACE,+BAAA;EACA,eAAA;AAAN;AAIE;EACE,QAAA;AAFJ;AAII;EACE,qDAAA;AAFN;;AAQE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AALJ;AAOI;EACE,aAAA;EACA,wBAAA;AALN;AAUQ;EACE,kBAAA;EACA,QAAA;AARV;AAWQ;EACE,YAAA;AATV;;AAgBA;EACE;IACE,uBAAA;EAbF;EAeA;IACE,yBAAA;EAbF;AACF","sourcesContent":[".video-info-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .published-at {\n    font-size: 14px;\n    color: var(--color_neutral_800);\n  }\n\n  .video-published-at {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .error-message {\n      color: var(--color_neutral_500);\n      font-size: 14px;\n    }\n  }\n\n  .update-post-button {\n    gap: 8px;\n\n    &__icon--spinning {\n      animation: update-post-button-spin 1s linear infinite;\n    }\n  }\n}\n\n.video-info {\n  .video-creator {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n\n    .video-creator-label {\n      margin: 0 4px;\n      color: var(--gray_dark1);\n    }\n\n    .video-creator-link {\n      .CreatorCardOnHover {\n        > h6 {\n          position: relative;\n          top: 4px;\n        }\n\n        .CreatorCardFetcher .CreatorCardMiniWithTolgee {\n          width: 265px;\n        }\n      }\n    }\n  }\n}\n\n@keyframes update-post-button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
